import { defineMessages } from 'react-intl';

const messages = defineMessages({
  carouselTitle: {
    defaultMessage: 'Shop fan art made by artists who love it too',
    description: 'Title for the carousel section',
  },
  shopAllLink: {
    defaultMessage: 'Shop {propertyName} merch',
    description: 'Link to a shop page for this Fan Art Property',
  },
  carouselTabHeadingSchittsCreek: {
    defaultMessage: 'Schitt’s Creek',
    description: 'Title for the Fan Art Property Schitt’s Creek',
  },
  carouselTabHeadingBobRoss: {
    defaultMessage: 'Bob Ross',
    description: 'Title for the Fan Art Property Bob Ross',
  },
  carouselTabHeadingDune: {
    defaultMessage: 'Dune',
    description: 'Title for the Fan Art Property Dune',
  },
  carouselTabHeadingAssassinsCreed: {
    defaultMessage: 'Assassin’s Creed',
    description: 'Title for the Fan Art Property Assassin’s Creed',
  },
});

export default messages;
